function b(n, t, e) {
  return t = c(t), function(o, r) {
    if (r && (typeof r == "object" || typeof r == "function")) return r;
    if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return function(u) {
      if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return u;
    }(o);
  }(n, p() ? Reflect.construct(t, e || [], c(n).constructor) : t.apply(n, e));
}
function p() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (p = function() {
    return !!n;
  })();
}
function y(n) {
  return y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, y(n);
}
function d(n, t) {
  if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function w(n, t, e) {
  return Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function O(n, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(t && t.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), t && i(n, t);
}
function c(n) {
  return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, c(n);
}
function i(n, t) {
  return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, o) {
    return e.__proto__ = o, e;
  }, i(n, t);
}
function s(n) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return s = function(e) {
    if (e === null || !function(r) {
      try {
        return Function.toString.call(r).indexOf("[native code]") !== -1;
      } catch {
        return typeof r == "function";
      }
    }(e)) return e;
    if (typeof e != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(e)) return t.get(e);
      t.set(e, o);
    }
    function o() {
      return function(r, u, a) {
        if (p()) return Reflect.construct.apply(null, arguments);
        var f = [null];
        f.push.apply(f, u);
        var l = new (r.bind.apply(r, f))();
        return a && i(l, a.prototype), l;
      }(e, arguments, c(this).constructor);
    }
    return o.prototype = Object.create(e.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), i(o, e);
  }, s(n);
}
export {
  y as _,
  O as a,
  w as b,
  s as c,
  d,
  b as e
};
//# sourceMappingURL=helpers-D3WySQMf.js.map
